<script>
import VSelect from 'vuetify/es5/components/VSelect/VSelect'
import { wrapperMixin } from './TextField'

export default {
    name: 'Combobox',
    extends: VSelect,
    mixins: [wrapperMixin]
}
</script>
